export enum FileType {
  None = 'None',
  PUMF2013 = 'PUMF CCHS 2013/14',
  Shared2013 = 'Shared CCHS 2013/14'
}
